import { Component, OnInit } from '@angular/core';
import { StoreService } from 'src/app/store.service';
import {
  ModalDismissReasons,
  NgbModal,
} from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';
import { UtilitiesService } from 'src/app/core/utilities.service';
import {
  SUBSCRIPTIONSTATUS
} from 'src/app/core/constants/data.constant';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'order-subscription-detail',
  templateUrl: './order-subscription-detail.component.html',
  styleUrls: ['./order-subscription-detail.component.scss'],
  providers: [DatePipe]
})
export class OrderSubscriptionDetailComponent implements OnInit {
  bearer;
  store_id;
  carts = [];
  expanded = [];
  allCarts = [];
  listData = [];
  page = 1;
  selectedPage = 20;
  start = 0;
  end = 0;
  dataIsLoading = true;
  email = '';
  storeId;
  id;
  filteredOrderType: string = '';

  orderId;
  pageSize = 20;
  statusFilters = [];
  orderPaginationList;

  closeResult = '';
  selectedcarts: any;
  orderDetailId;
  subscripitonDetail;
  attData;
  pdfSrc;

  constructor(
    private svc: StoreService,
    private modalService: NgbModal,
    public utils: UtilitiesService,
    private datePipe: DatePipe,
    private activeRoute: ActivatedRoute,
    private sanitizer: DomSanitizer
  ) {
  }
  

  ngOnInit(): void {
    this.bearer = localStorage.getItem('bearer');
    this.store_id = localStorage.getItem('store_id');

    const orderDetailId = this.activeRoute.snapshot.params.id;
    // const langCode = this.activeRoute.snapshot.params.langCode ?? 'en-US';
    this.orderDetailId = orderDetailId;

  
    this.getSubscriptionDetail();
  }

  getSubscriptionDetail(){
    this.orderId = '';
    this.dataIsLoading = true;
    this.svc
      .getSubscriptionDetail(
        this.bearer,
        this.store_id,
        this.orderDetailId,
      )
      .subscribe(
        (res) => {
          this.subscripitonDetail = res['data'];
          this.dataIsLoading = false;
        },
        (error) => {
          this.dataIsLoading = false;
        }
      );
  }

  private static getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  sliceRecord(data) {
    this.start = Math.round((this.page - 1) * this.selectedPage);
    this.end = this.start + this.selectedPage;
    this.end = this.end > data.length ? data.length : this.end;
    this.end = this.end > this.start ? this.end : this.start;
    return data.slice(this.start, this.end);
  }


  getSubscriptionStatus(key) {
    return SUBSCRIPTIONSTATUS[key?.toUpperCase()];
  }

  public getWindowType(): string {
    if (window.innerWidth >= 560 && window.innerWidth < 761) {
      return 'tablet';
    } else if (window.innerWidth >= 340 && window.innerWidth < 560) {
      return 'mobile';
    } else {
      return 'screen';
    }
  }

  convertDate(dateString: string): string {
    const date = new Date(dateString);
    return this.datePipe.transform(date, 'MMMM d, y');
  }

  convertRecurringDateDate(dateString: string): string {
    if(dateString === "0000-00-00" || dateString === "" || dateString === undefined){
      return "-"
    }else{
    const date = new Date(dateString);
    return this.datePipe.transform(date, 'MMM d, y');
    }
  }

  getStatus(key) {
    return SUBSCRIPTIONSTATUS[key?.toUpperCase()];
  }

  openAttachement(attachement){
    this.attData = attachement[0].link;
    this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(`https://docs.google.com/gview?url=${encodeURIComponent(this.attData)}&embedded=true`);
  }

  openPDF(content) {
   this.modalService.open(content, { size: 'lg' });
  }
}
